<template lang="pug">
.crono(:class="{ 'crono--fim': acabou, 'crono--pausado': !rodando && !acabou }")
  .crono__topo
    span.crono__estado(v-if="acabou") Tempo esgotado
    span.crono__estado(v-else-if="contagem") Preparar
    span.crono__estado(v-else-if="rodando") Em andamento
    span.crono__estado(v-else) Pausado
    span.crono__robos(v-if="titulo") {{ titulo }}

  //- Tela de projeção: só o número. Sem botões, porque quem controla é o juiz
  //- na tela dele. A barra de espaço continua pausando aqui, para quando esta
  //- aba estiver com o foco.
  .crono__tempo {{ contagem || texto }}
</template>

<script>
import {
  DURACAO_PADRAO_MS,
  ler,
  observar,
  restanteDe,
  contagemDe,
  alternar,
  formatar
} from '@/utils/cronometro'

export default {
  name: 'Cronometro',
  data: () => ({
    estado: null,
    restante: DURACAO_PADRAO_MS,
    contagem: null,
    tick: null,
    parar: null
  }),
  created () {
    this.estado = ler()
    this.recalcular()
    // 200ms: o relógio vem do instante do fim, então o intervalo é só o refresh
    // da tela — não é ele que conta o tempo.
    this.tick = setInterval(this.recalcular, 200)
    this.parar = observar((novo) => {
      this.estado = novo
      this.recalcular()
    })
    window.addEventListener('keydown', this.doTecla)
  },
  beforeDestroy () {
    clearInterval(this.tick)
    if (this.parar) this.parar()
    window.removeEventListener('keydown', this.doTecla)
  },
  computed: {
    rodando () {
      return !!(this.estado && this.estado.rodando) && this.restante > 0
    },
    acabou () {
      return this.restante <= 0
    },
    texto () {
      return formatar(this.restante)
    },
    // nomes dos robôs vêm por query da tela do juiz (a aba nova não tem store)
    titulo () {
      const { azul, vermelho } = this.$route.query
      if (azul && vermelho) return azul + '  ×  ' + vermelho
      return azul || vermelho || ''
    },
    fightId () {
      return Number(this.$route.query.luta || 0) || (this.estado && this.estado.fightId) || 0
    }
  },
  methods: {
    recalcular () {
      this.restante = restanteDe(this.estado)
      this.contagem = contagemDe(this.estado)
    },
    doAlternar () {
      this.estado = alternar(this.estado, this.fightId)
      this.recalcular()
    },
    doTecla (e) {
      if (e.code !== 'Space' && e.key !== ' ') return
      e.preventDefault() // senão a barra rola a página
      this.doAlternar()
    }
  }
}
</script>

<style lang="sass" scoped>
  $ink: #0B0E14
  $green: #2E9E4F
  $gold: #F9A825
  $red: #DD3434
  $display: 'Saira Condensed', 'Lato', sans-serif
  $mono: 'Space Mono', 'Lato', monospace

  .crono
    position: fixed
    inset: 0
    z-index: 2000
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center
    gap: 24px
    background: radial-gradient(circle at 50% 30%, #15233b 0%, $ink 60%, #05070b 100%)
    color: #fff
    text-align: center
    padding: 24px

    &__topo
      display: flex
      flex-direction: column
      align-items: center
      gap: 10px

    &__estado
      font-family: $display
      font-size: clamp(16px, 2.4vw, 26px)
      letter-spacing: 0.22em
      text-transform: uppercase
      color: $green

    &__robos
      font-family: $display
      font-size: clamp(18px, 3vw, 34px)
      letter-spacing: 0.06em
      text-transform: uppercase
      color: rgba(255, 255, 255, 0.72)

    // o número ocupa a largura da tela: é para ser lido de longe, na arena
    &__tempo
      font-family: $mono
      font-weight: 700
      font-size: clamp(96px, 34vw, 520px)
      line-height: 0.9
      letter-spacing: -0.02em
      font-variant-numeric: tabular-nums

    &--pausado &__estado
      color: $gold
    &--pausado &__tempo
      color: rgba(255, 255, 255, 0.72)

    &--fim
      background: radial-gradient(circle at 50% 30%, #4a0d0d 0%, #1a0505 60%, #05070b 100%)
    &--fim &__estado
      color: $red
    &--fim &__tempo
      color: $red
      animation: cronoPisca 1s steps(2, start) infinite

  @keyframes cronoPisca
    to
      opacity: 0.35
</style>
